import React from 'react';
import PropTypes from 'prop-types';
import HeaderSection from '../components/HeaderSection';
import ButtonSection from '../components/ButtonSection';
import InputSection from '../components/InputSection';
import { CHANGE, DEFAULT } from '../constants';

const Change = ({
  label,
  labelBtn,
  form,
  errors,
  loading,
  onChange,
  onSave,
  onToggle,
}) => (
  <div>
    <HeaderSection labelTitle={label.title} labelSubtitle={label.subTitle} />

    <div className="row">
      <InputSection
        className="col-sm-4 col-xs-12"
        placeholder={label.input.placeholder}
        name="current_pin"
        label={label.input.currentPin}
        error={errors.current_pin}
        value={form.current_pin || ''}
        onChange={onChange}
      />

      <InputSection
        className="col-sm-4 col-xs-12"
        placeholder={label.input.placeholder}
        name="new_pin"
        label={label.input.newPin}
        error={errors.new_pin}
        value={form.new_pin || ''}
        onChange={onChange}
      />

      <InputSection
        className="col-sm-4 col-xs-12"
        placeholder={label.input.placeholder}
        name="repeat_pin"
        label={label.input.confirmPin}
        error={errors.repeat_pin}
        value={form.repeat_pin || ''}
        onChange={onChange}
      />
    </div>

    <ButtonSection
      labelCancel={labelBtn.btnCancel}
      labelExec={labelBtn.btnChangePin}
      loading={loading}
      onToggle={() => onToggle(DEFAULT)}
      onExec={() => onSave(CHANGE)}
    />
  </div>
);

Change.propTypes = {
  label: PropTypes.object,
  labelBtn: PropTypes.object,
  loading: PropTypes.bool,
  errors: PropTypes.object,
  form: PropTypes.object,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  onToggle: PropTypes.func,
};
export default Change;
